import http from '../http-common'

export default class DashboardServices {
   
    async adherenceToCourse(filter){
        let res = await http.post(`v1/report/adherence-to-courses`, filter);
        return res.data;
    }

    async assertivenessInAssessments(filter){
        let res = await http.post(`v1/report/assertiveness-in-assessments`, filter);
        return res.data;
    }

    async reportAdherenceCourse(filter){
        let res = await http.post(`v1/report/report-adherence-course`, filter);
        return res.data;
    }

    async numberActiveInactiveUsers(filter){
        let res = await http.post(`v1/report/number-active-inactive-users`, filter);
        return res.data;
    }

    async studentRankingTableTop1Student(filter){
        let res = await http.post(`v1/report/student-ranking-table-TOP1-student`, filter);
        return res.data;
    }


    
    async studentRankingIntegrationsTop5Student(filter){
        let res = await http.post(`v1/report/user-chat-integrations`, filter);
        return res.data;
    }

    

    async numberOfSudentInteractions(filter){
        let res = await http.post(`v1/report/number-student-interactions`, filter);
        return res.data;
    }

    async numberInteractionsAdministrators(filter){
        let res = await http.post(`v1/report/number-interactions-administrators`, filter);
        return res.data;
    }

    async interactionsPosts(filter){
        let res = await http.post(`v1/report/interactions-in-posts`, filter);
        return res.data;
    }

    async interactionsChat(filter){
        let res = await http.post(`v1/report/chat-interactions`, filter);
        return res.data;
    }


}